// USA
export const locale = {
	lang: 'pk',
	data: {
		TITLE_NAME: 'ہائر ایجوکیشن کمیشن ، پاکستان',
		DOWNLOAD_MANUAL: 'کتابچَہ ڈاؤن لوڈ کریں',
		HI: 'خوش آمدید',
		TRANSLATOR: {
			SELECT: 'Select your language',
		},
		MENU: {
			DASHBOARD: 'ڈیش بورڈ',
			DEGREE_ATTESTATION: 'ڈگری کی تصدیق ',
			TRACK_APPLICATIONS: 'ٹریک ایپلی کیشنز',
			NEW: 'new',
			ACTIONS: 'Actions',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
		},
		AUTH: {
			GENERAL: {
				OR: 'Or',
				SUBMIT_BUTTON: 'Submit',
				NO_ACCOUNT: 'Don\'t have an account?',
				SIGNUP_BUTTON: 'Sign Up',
				FORGOT_BUTTON: 'Forgot Password ?',
				BACK_BUTTON: 'Back',
				PRIVACY: 'Privacy',
				LEGAL: 'Legal',
				CONTACT: 'Contact',
			},
			LOGIN: {
				TITLE: 'Login Account',
				BUTTON: 'Sign In',
			},
			FORGOT: {
				TITLE: 'Forgotten Password?',
				DESC: 'Enter your email to reset your password',
				SUCCESS: 'Your account has been successfully reset.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				EMAIL: 'Email',
				FULLNAME: 'Fullname',
				PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				USERNAME: 'Username'
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
			}
		},
		COMMON_MESAGES:{
			RESEND_CODE:'کوڈ کو دوبارہ بھیجیں',
			SECONDS:'سیکنڈ',
			VERIFY_CODE:'کوڈ کی تصدیق کریں'
		},
		ACTIONS_BTNS:{
			SAVE_CLOSE:'محفوظ کریں اور بند کریں',
			CLOSE:'بند کریں',
			CANCEL_BTN:'منسوخ کریں'
		},
		DASHBOARD:{
			ANNOUNCEMENTS:'اعلانات',
			WELCOME:'خوش آمدید',
			BACK:'خوش آمدید',
			LAST_LOGIN:'آخری لاگ ان سے :',
			REFRESH_SECTION:'دوبارہ لوڈ کریں',
			MY_APPLICATIONS:'میری درخواستیں',
			TASKS_ASSIGN:'مجھے تفویض کردہ ٹاسک',
			SUGGESTED_TO_YOU:'تجویز کردہ',
			PROFILE_STRENGTH:'پروفائل کی طاقت',
			UPDATE_PROFILE:'پروفائل کو اپ ڈیٹ کریں',
			RECENT_ACTIVITIES:'تازہ ترین درخواست پر حالیہ سرگرمیاں',
			APPLICATION_TABLE:{
				FILTER:'فلٹر کریں',
				APP_ID:'درخواست کی شناخت',
				APP_TYPE:'درخواست کی قسم',
				DATE:'تاریخ',
				STATUS:'حیثیت',
				VIEW_APP_STATUS:'درخواست کی حیثیت دیکھیں',
				VIEW_APP:'درخواست دیکھیں',
				VIEW_EDIT:'دیکھیں / ترمیم',
				DOWNLOAD_FORM:'فارم ڈاؤن لوڈ',
				DOWNLOAD_APP_FORM:'درخواست فارم ڈاؤن لوڈ کریں',
				NO_RECORD_FOUND:'کوئی ریکارڈ نہیں',
				SAVED:'محفوظ',
				SUBMITTED:'داخل کیا ہوا',
				PENDING:'ابھی نا مکمل',
				APPLICATION_PROCESSING:'پروسیسنگ',
				APPROVED:'منظور',
				PRE_APPROVED:'عارضی طور پر منظور شدہ',
				REJECTED:'مسترد',
				REVISION_REQUESTED:'نظرثانی کی درخواست',
				LOCAL_DES_CANCELLED:'منسوخ',
				DAS:'ڈگری تصدیق سروس',
				DES:'ڈگری ایکویلینس سروس',
				DESF:'Foreign DES'
			},
			PROFILE_STRENGTH_SECTION:{
				COMPLETE:'مکمل',
				PROFILE_PICTURE:'پروفائل تصویر',
				PERSONAL_DETAILS:'ذاتی معلومات',
				CONTACT_DETAILS:'رابطہ کی تفصیلات',
				ADDRESS_DETAILS:'پتہ کی تفصیلات',
				EDUCATION_DETAILS:'تعلیم کی تفصیلات',
				PERCENT:'٪'
			},
			ASSIGNED_TASKS:{
				FILTER:'فلٹر کریں',
				NO_RECORD_FOUND:'کوئی ریکارڈ نہیں',
				DAS:'ڈگری تصدیق سروس',
				DES:'ڈگری ایکویلینس سروس',
				DESF:'Foreign Degree Equivalence Service',
				APP_ID:': درخواست کی شناخت',
				APPOINTMENT_DATE:': تعیناتی کی تاریخ',
				APPOINTMENT_TIME:': تعیناتی کا وقت',
				REGIONAL_CENTER:': علاقائی مرکز',
				VIEW_COMMENTS:'تبصرے دیکھیں',
				VIEW_TASK_DETAILS:'ٹاسک کی تفصیلات دیکھیں',
				PAY_FEE: 'ادائیگی کی تفصیلات دیکھیں',
			},
			SUGGESTED_SERVICES:{
				APPLY_DAS:'ڈگری تصدیق سروس کے لئے درخواست دیں'
			}
		},
		COMMOM_PROFILE:{
            MAIN_HEADING:'ذاتی معلومات',
            DOWNLOAD_MANUAL:'پروفائل دستی ڈاؤن لوڈ کریں',
            EMAIL:'ای میل',
            PHONE:'فون',
            LOCATION:'مقام',
            MENU_HEADINGS:{
				PERSONAL_INFORMATION:'ذاتی معلومات',
				ADDRESS_INFORMATION:'ایڈریس کی معلومات',
				EDUCATION_INFORMATION:'تعلیم کی تفصیلات',
				CHANGE_PASSWORD:'پاس ورڈ تبدیل کریں',
				CHANGE_EMAIL:'ای میل تبدیل کریں',
				CHANGE_MOBILE:'موبائل نمبر تبدیل کریں'
            },
			NEXT_STEP:'اگلا قدم',
			APPLY_FOR_DAS:'ڈگری تصدیق کے لئے درخواست دیں',
			PERSONAL_DETAILS:{
				MAIN_HEADING:'کچھ اپنے بارے میں بتائیں',
				MAIN_HEADING2:'سوانحی معلومات',
				MAIN_HEADING3:"والد کی اطلاع",
				MAIN_HEADING4:'قومیت سے متعلق معلومات',
				TITLE:':عہدہ',
				FIRST_NAME:':پہلا نام',
				MIDDLE_NAME:':درمیانی نام',
				LAST_NAME:':آخری نام',
				CELL_PHONE:':موبائل فون',
				GENDER:':صنف',
				RELIGION:':مذہب',
				MARTIAL_STATUS:':ازدواجی حیثیت',
				DATE_OF_BIRTH:':پیدائش کی تاریخ',
				DOMICILE_PROVINCE:':ڈومیسائل صوبہ',
				DOMICILE_CITY:':ڈومیسائل شہر',
				DOMICILE_DISTRICT:':ڈومیسائل ضلع',
				COUNTRY_OF_BIRTH:':وطن پیدائش',
				AGE:':عمر',
				FATHER_NAME:':والد کا نام',
                FATHER_CNIC:':والد کاCNIC ',
                FATHER_STATUS:':والد کی حیثیت',
				FATHER_CURRENTLY_EMPLOYED:':والد فی الحال ملازم ہے',
				FATHER_OCCUPATION:':والد کا پیشہ',
				IDENTIFICATION:'شناخت',
				TYPE:'ٹائپ',
				COUNTRY:'ملک',
				EDIT_DETAILS:'تفصیلات میں ترمیم کریں',
				INPUTS:{
					TITLE:'عہدہ',
					TITLE_TOOLTIP:'براہ کرم عہدہ منتخب کریں',
				FIRST_NAME:'پہلا نام',
				FIRST_NAME_TOOLTIP:'براہ کرم پہلا نام درج کریں',
				MIDDLE_NAME:'درمیانی نام',
				MIDDLE_NAME_TOOLTIP:'براہ کرم  درمیانی نام درج کریں',
				LAST_NAME:'آخری نام',
				LAST_NAME_TOOLTIP:'براہ کرم آخری نام درج کریں',
				CELL_PHONE:'موبائل فون',
				GENDER:'صنف',
				RELIGION:'مذہب',
				RELIGION_TOOLTIP:'براہ کرم مذہب کو منتخب کریں',
				MARTIAL_STATUS:'ازدواجی حیثیت',
				DATE_OF_BIRTH:'پیدائش کی تاریخ',
				DATE_OF_BIRTH_TOOLTIP:'براہ کرم تاریخ پیدائش منتخب کریں',
				DOMICILE_PROVINCE:'ڈومیسائل صوبہ',
				DOMICILE_PROVINCE_TOOLTIP:'براہ کرم ڈومیسائل صوبہ منتخب کریں',
				DOMICILE_CITY:'ڈومیسائل شہر',
				DOMICILE_CITY_TOOLTIP:'براہ کرم ڈومیسائل شہر منتخب کریں',
				DOMICILE_DISTRICT:'ڈومیسائل ضلع',
				DOMICILE_DISTRICT_TOOLTIP:'براہ کرم ڈومیسائل ضلع منتخب کریں',
				COUNTRY_OF_BIRTH:'وطن پیدائش',
				COUNTRY_OF_BIRTH_TOOLTIP:'براہ کرم پیدائشی ملک کا انتخاب کریں',
				AGE:'عمر',
				FATHER_NAME:'والد کا نام',
				FATHER_NAME_TOOLTIP:'برائے مہربانی والد کا نام درج کریں',
                FATHER_CNIC:'والد کاCNIC ',
                FATHER_CNIC_TOOLTIP:'براہ کرم والد cnic داخل کریں',
                FATHER_STATUS:'والد کی حیثیت',
                FATHER_STATUS_TOOLTIP:'براہ کرم والد کی حیثیت منتخب کریں',
				FATHER_CURRENTLY_EMPLOYED:'فی الحال ملازم ہے',
				FATHER_OCCUPATION:'والد کا پیشہ',
				FATHER_OCCUPATION_TOOLTIP:'براہ کرم والد کا پیشہ منتخب کریں',
				IDENTIFICATION:'شناختی نمبر',
				TYPE:'ٹائپ',
				COUNTRY:'ملک',
				ACTIONS:'فعل',
				EDIT_PICTURE:'تصویر میں ترمیم کریں'
					}
			},
			CONTACT_DETAILS:{
				INPUT:{
					SAME_AS_PERMANENT:'مستقل ایڈریس کی طرح',
					ADDRESS:'پتہ',
					ADDRESS_HINT:'براہ کرم پتہ درج کریں',
					DISTRICT:'ضلع',
					DISTRICT_HINT:'براہ کرم ضلع منتخب کریں',
					CITY:'شہر',
					CITY_HINT:'براہ کرم شہر منتخب کریں',
					POSTAL_CODE:'ڈاک کامخصوص نمبر',
					POSTAL_CODE_HINT:'برائے کرم پوسٹل کوڈ منتخب کریں',
					COUNTRY:'ملک',
					COUNTRY_HINT:'براہ کرم ملک منتخب کریں',
					ADDRESS_DETAILS:'پتہ کی تفصیلات',
					SAVE_ADDRESS_BTN:'پتہ محفوظ کریں۔',
					CANCEL_BTN:'منسوخ کریں'
				},
				SAME_AS_PERMANENT:'مستقل ایڈریس کی طرح',
				ADDRESS:'پتہ:',
				ADDRESS_HINT:'براہ کرم پتہ درج کریں',
				DISTRICT:'ضلع:',
				DISTRICT_HINT:'براہ کرم ضلع منتخب کریں',
				CITY:'شہر:',
				CITY_HINT:'براہ کرم شہر منتخب کریں',
				POSTAL_CODE:'ڈاک کامخصوص نمبر:',
				POSTAL_CODE_HINT:'برائے کرم پوسٹل کوڈ منتخب کریں',
				COUNTRY:'ملک:',
				COUNTRY_HINT:'براہ کرم ملک منتخب کریں',
				ADDRESS_DETAILS:'پتہ کی تفصیلات',
				SAVE_ADDRESS_BTN:'پتہ محفوظ کریں۔',
				CANCEL_BTN:'منسوخ کریں',
				PERMANENT:'مستقل پتہ',
				MAILING:'ڈاک کاپتہ',
				CURRENT:'موجودہ پتہ',
			},
			EDUCATION_DETAILS:{
				ADD_EDUCATION:'تعلیم شامل کریں',
				NO_EDUCATION:'ابھی تک تعلیم نہیں ہے',
				ADD_ATLEAST_EDUCATION:'فی الحال آپ کے پاس سسٹم میں کوئی تعلیم نہیں ہے ، براہ کرم جاری رکھنے کے لئے کم از کم ایک شامل کریں',
				APPLY_DAS:'ڈگری تصدیق کے لئے درخواست دیں',
				VIEW:'دیکھیں',
				EDIT:'ترمیم کریں',
				DELETE:'حذف کریں',
				EQUIVALENCE_ISSUED:'مساوات جاری',
				VERIFIED:'تصدیق شدہ',
				LOCKED:'مقفل ہے',
				EDUCATION_FORM:{
					QUALIFICATION_DETAILS_HEADING:'اہلیت کی تفصیلات',
					QUALIFICATION_DETAILS_DESC:'اپنی اہلیت کی تفصیلات نیچے والے فیلڈز میں درج کریں',
					DEGREE_CERTIFICATE_HEADING:'ڈگری / سرٹیفکیٹ دینے والے انسٹی ٹیوٹ کی تفصیلات',
					DEGREE_CERTIFICATE_DESC:'اپنی ڈگری اور سرٹیفیکیشن کی تفصیلات ٹائپ کریں',
					ACADEMIC_DETAILS_HEADING:'تعلیمی کارکردگی کی تفصیلات',
					ACADEMIC_DETAILS_DESC:'اپنی تعلیمی کارکردگی کی تفصیلات ٹائپ کریں',
					MISSING_UNI_MESSAGE1:' اگر آپ کے کیمپس / کالج / ڈگری ٹائٹل کی تفصیلات دستیاب نہیں ہیں تو ، براہ کرم اپنی یونیورسٹی کے فوکل پرسن سے رابطہ کریں یا یہاں شکایت درج کریں',
					MISSING_UNI_MESSAGE2:' اور سروس ٹیب میں پاکستان قابلیت رجسٹر (PQR) کو منتخب کریں۔ فوکل پرسن کی فہرست چیک کرنے کے لئے ، براہ کرم یہاں کلک کریں',
					INPUTS:{
						QUALIFICATION_LEVEL:'Qualification Level',
						QUALIFICATION_LEVEL_HINT:'Please select qualification level',
						INCOMPLETE_EDUCATION:'Incomplete Education',
						CURRENTLY_ENROLLED:'Currently Enrolled',
						START_DATE:'Start Date',
						START_DATE_HINT:'Please select start date',
						END_DATE_HINT:'Please select end date',
						END_DATE:'End Date',
						EXPECTED_END_DATE:'Expected End Date',
						NAME_ON_DEGREE:'Name on Degree',
						NAME_ON_DEGREE_HINT:'Please enter your name as written on degree',
						COUNTRY:'Country',
						COUNTRY_HINT:'Please select country',
						CITY:'City',
						CITY_HINT:'Please select city',
						DEGREE_AWARDING_INSTITUTE:'Degree Awarding Institute',
						DEGREE_AWARDING_INSTITUTE_HINT:'Please select degree awarding institute',
						DEGREE_AWARDING_INSTITUTE_BOARD:'Degree Awarding Institute / Board',
						DEGREE_AWARDING_INSTITUTE_BOARD_HINT:'Please enter degree awarding institute/board',
						SCHOOL_COLLEGE:'School / College',
						SCHOOL_COLLEGE_HINT:'Please enter school/college name',
						INSTITUTE_SECTOR:'Institute/Sector',
						INSTITUTE_SECTOR_HINT:'Please select institute/sector',
						PROGRAM_TITLE:'Program Title',
						PROGRAM_TITLE_HINT:'Please select program title',
						DISCIPLINE:'Discipline',
						DISCIPLINE_HINT:'Please select discipline',
						OTHER_DEGREE_AWARDING_INSTITUE:'Other Degree Awarding Institute',
						OTHER_DEGREE_AWARDING_INSTITUE_HINT:'Please enter other degree awarding institute',
						UNIVERSITY_NAME_ON_DEGREE:'University Name on Degree',
						UNIVERSITY_NAME_ON_DEGREE_HINT:'Please select university name on degree',
						CAMPUS:'Campus',
						CAMPUS_HINT:'Please select campus',
						CAMPUS_HINT1:'Please enter campus',
						DEPARTMENT:'Department',
						DEPARTMENT_SELECT_HINT:'Please select department',
						DEPARTMENT_ENTER_HINT:'Please enter department',
						DEGREE_TYPE:'Degree Type',
						DEGREE_TYPE_HINT:'Please select degree type',
						SESSION_TYPE:'Session Type',
						SESSION_TYPE_HINT:'Please select session type',
						MAJOR:'Major',
						MAJOR_HINT:'Please select major',
						RESEARCH_WORK:'Research work only',
						AREA_RESEARCH:'Area of Research',
						AREA_RESEARCH_HINT:'Please enter area of research',
						TITLE_DISSERTATION:'Title of Dissertation',
						TITLE_DISSERTATION_HINT:'Please enter title of dissertation',
						REGISTRATION_NUMBER:'Registration/Roll Number',
						REGISTRATION_NUMBER_HINT:'Please enter registration/roll number',
						EDUCATION_SYSTEM:'Education System',
						EDUCATION_SYSTEM_HINT:'Please select education system',
						GRADING_SYSTEM:'Grading System',
						GRADING_SYSTEM_HINT:'Please select grading system',
						TOTAL_GPA:'Total CGPA',
						TOTAL_GPA_HINT:'Please select total gpa',
						TOTAL_MARKS:'Total Marks',
						TOTLA_MARKS_HINT:'Please enter total marks',
						OBTAINED_PERCENTAGE:'Obtained Percentage',
						PLACEHOLDER_OBTAINED_PERCENTAGE:'Enter Obtained Percentage',
						OBTAINED_PERCENTAGE_HINT:'Please enter obtained percentage'
					}
				}
				
			},
			CHANGE_PASSWORD:{
				SUB_HEADING:'اپنے اکاؤنٹ کا پاس ورڈ تبدیل یا دوبارہ ترتیب دیں',
				WARNING_MSG:'ایک بار جب آپ کا پاس ورڈ اپ ڈیٹ ہوجاتا ہے ، آپ کو ای سرویس پورٹل سے لاگ آؤٹ کردیا جائے گا۔ آپ کو نئے پاس ورڈ کے ساتھ دوبارہ سائن ان کرنا ہوگا۔',
				CURRENT_PASSWORD:'موجودہ پاس ورڈ',
				CURRENT_PASSWORD_HINT:'براہ کرم موجودہ پاس ورڈ درج کریں',
				NEW_PASSWORD:'نیا پاس ورڈ',
				NEW_PASSWORD_HINT:'براہ کرم پاس ورڈ درج کریں کم از کم 8 حروف لمبا ، حرفی نمبر ہونا چاہئے اور اس میں کم از کم ایک بڑے  بڑے حرف پر مشتمل ہونا چاہئے',
				CONFIRM_NEW_PASSWORD:'پاس ورڈ کی تصدیق کریں',
				CONFIRM_NEW_PASSWORD_HINT:'تصدیق کے لئے براہ کرم پاس ورڈ درج کریں'
			},
			CHANGE_EMAIL:{
				SUB_HEADING:'اپنے اکاؤنٹ کا ای میل تبدیل کریں',
				PRIMARY_EMAIL:'بنیادی ای میل',
				PRIMARY_EMAIL_HINT:'براہ کرم ای میل کو درست شکل میں داخل کریں جیسے: username@provider.com',
				VERIFICATION_CODE_HINT:'براہ کرم نئے ای میل سے ای میل کی توثیق 5 ہندسوں کا کوڈ درج کریں',
				EMAIL_CODE:'ای میل کوڈ',
				PLACEHOLDER_EMAIL_CODE:'ای میل کوڈ درج کریں',
			},
			CHANGE_PHONE:{
				SUB_HEADING:'اپنا اکاؤنٹ فون نمبر تبدیل کریں',
				PRIMARY_PONENUMBER:'بنیادی موبائل فون نمبر',
				PRIMARY_PHONENUMBER_HINT:'براہ کرم فون نمبر صحیح شکل میں درج کریں جیسے: +92 3472748202',
				PRIMARY_PHONENUMBER_REQUIRED:'فون نمبر ضروری ہے',
				PRIMARY_PHONENUMBER_ERROR:'درست فون نمبر درج کریں',
				VERIFICATION_CODE_HINT:'برائے کرم رجسٹرڈ فون نمبر سے فون نمبر کی توثیق 5 ہندسوں کا کوڈ درج کریں',
				PHONENUMBER_CODE:'فون نمبر کوڈ',
				PLACEHOLDER_PHONENUMBER_CODE:'فون نمبر کوڈ درج کریں',
			}


		}
	}
};
